import { DiseaseContentModel } from './diseaseContentModel';

export class DiseaseForGridModel {
  public diseaseId: number;
  public diseaseNameBG: string;
  public diseaseNameEN: string;
  public diseaseCode: string;
  public diseaseContent: Array<DiseaseContentModel>;
}